import React, { Suspense, useEffect } from 'react'
import AppFallback from './utils/routes/AppFallback'
import { notification } from 'antd'
import ToastProvider from './components/Toast/ToastContext'
import AppRoutes from './utils/routes/AppRoutes'
import { PlayerProvider } from './components/Player/PlayerContext'

import { initParticlesEngine } from '@tsparticles/react'
import { loadSlim } from '@tsparticles/slim'

function App() {
  const [api, toastContextHolder] = notification.useNotification({
    stack: false,
    maxCount: 4,
  })

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine)
    })
  }, [])

  return (
    <Suspense fallback={<AppFallback />}>
      {toastContextHolder}
      <ToastProvider api={api}>
        <PlayerProvider>
          <AppRoutes />
        </PlayerProvider>
      </ToastProvider>
    </Suspense>
  )
}

export default App
